import {
    Box,
    VStack,
    Text,
    Button,
    Image,
    PinInput,
} from "@chakra-ui/react";

import {
    useState,
    useEffect,
} from "react";

import {
    useNavigate,
    useLocation,
} from "react-router-dom";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Logo from "../../../../assets/logo.png";
import routes from "../../../../routes";

import {
    verifyOtpAction,
    passwordResetAction
} from "../../../../state/actions/authActions";

import {
    toaster,
} from "../../../../components/toaster";

import ActivityToast from "../../../../components/ActivityToast";

const VerifyOtpForm = () => {
    const navigate =
        useNavigate();

    const location =
        useLocation();

    const dispatch =
        useDispatch();

        const [
    resendTimer,
    setResendTimer,
] = useState(60);

const [
    resending,
    setResending,
] = useState(false);

    const {
        loading,
    } = useSelector(
        (state) =>
            state.auth
    );

    const {
        user_id,
        email,
    } =
        location.state || {};
        

    const [
        otp,
        setOtp,
    ] = useState("");
   useEffect(() => {
    if (
        resendTimer <= 0
    ) {
        return;
    }

    const timer =
        setTimeout(() => {
            setResendTimer(
                prev =>
                    prev - 1
            );
        }, 1000);

    return () =>
        clearTimeout(
            timer
        );
}, [resendTimer]);
useEffect(() => {
    if (!email || !user_id) {
        toaster.create({
            render: () => (
                <ActivityToast
                    type="warning"
                    title="Verification Session Expired"
                    description="Your verification session could not be found. Please contact an administrator to activate your account or restart registration."
                    timestamp="Just now"
                />
            ),
        });

        navigate(
            routes.register,
            {
                replace: true,
            }
        );
    }
}, [
    email,
    user_id,
    navigate,
]);
    const handleVerify =
        async () => {
            const result =
                await dispatch(
                    verifyOtpAction(
                        {
                            user_id,
                            otp: Number(
                                otp
                            ),
                        }
                    )
                );

            if (
                result?.success
            ) {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="success"
                            title="Verification Successful"
                            description="Your account has been verified successfully."
                            timestamp="Just now"
                        />
                    ),
                });

                setTimeout(
                    () => {
                        navigate(
                            routes.login,
                            
                        );
                    },
                    1000
                );
            } else {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="error"
                            title="Verification Failed"
                            description={
                                result?.error ||
                                "Invalid verification code."
                            }
                            timestamp="Just now"
                        />
                    ),
                });
            }
        };

        const handleResend =
    async () => {
        
        if (
            resendTimer > 0 ||
            !email
        ) {
            return;
        }

        setResending(
            true
        );

        const result =
            await dispatch(
                passwordResetAction(
                    email
                )
            );

        setResending(
            false
        );

        if (
            result?.success
        ) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="success"
                        title="OTP Resent"
                        description="A new verification code has been sent to your email."
                        timestamp="Just now"
                    />
                ),
            });

            setResendTimer(
                60
            );
        } else {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Resend Failed"
                        description={
                            result?.error ||
                            "Unable to resend OTP."
                        }
                        timestamp="Just now"
                    />
                ),
            });
        }
    };
    return (
        <Box
            p={{
                base: 6,
                md: 10,
                lg: 20,
            }}
        >
            <Box
                textAlign="center"
                mb={10}
            >
                <Image
                    src={Logo}
                    h="52px"
                    mx="auto"
                    mb={12}
                />

                <Text
                    fontSize={{
                        base: "36px",
                        md: "48px",
                    }}
                    fontWeight="700"
                    color="#071D54"
                    mb={3}
                    lineHeight="1.1"
                >
                    Verify Your
                    Account
                </Text>

                <Text
                    color="gray.600"
                    maxW="420px"
                    mx="auto"
                >
                    Enter the
                    6-digit
                    verification
                    code sent
                    to your
                    registered
                    email.
                </Text>

                {email && (
                    <Text
                        mt={3}
                        fontWeight="600"
                        color="#2453FF"
                    >
                        {email}
                    </Text>
                )}
            </Box>

            <VStack
                gap={8}
            >
              <PinInput.Root
                otp
                onValueChange={(e) =>
                    setOtp(e.value.join(""))
                }
            >
                <PinInput.HiddenInput />

                <PinInput.Control>
                    <PinInput.Input index={0} />
                    <PinInput.Input index={1} />
                    <PinInput.Input index={2} />
                    <PinInput.Input index={3} />
                    <PinInput.Input index={4} />
                    <PinInput.Input index={5} />
                </PinInput.Control>
            </PinInput.Root>
                <Button
                    w="100%"
                    size="lg"
                    bg="#2453FF"
                    color="white"
                    _hover={{
                        bg: "#1E46D8",
                    }}
                    loading={
                        loading
                    }
                    loadingText="Verifying..."
                    disabled={
                        otp.length !==
                        6
                    }
                    onClick={
                        handleVerify
                    }
                >
                    Verify OTP
                </Button>

               <VStack gap={2}>
                    <Text
                        color="gray.500"
                        fontSize="sm"
                    >
                        Didn't receive the code?
                    </Text>

                    <Button
                        variant="ghost"
                        color="#2453FF"
                        fontWeight="600"
                        size="sm"
                        loading={
                            resending
                        }
                        disabled={
                            resendTimer >
                            0
                        }
                        onClick={
                            handleResend
                        }
                    >
                        {resendTimer >
                        0
                            ? `Resend in ${resendTimer}s`
                            : "Resend Code"}
                    </Button>
                </VStack>

                <Text
                    color="#2453FF"
                    cursor="pointer"
                    fontWeight="500"
                    onClick={() =>
                        navigate(
                            routes.register
                        )
                    }
                >
                    ← Back
                </Text>
            </VStack>
        </Box>
    );
};

export default VerifyOtpForm;